import { BaseDataElement } from './base-data-element.model';

export class NumericDataElement extends BaseDataElement {

  minimum: Number;
  maximum: Number;

  minimumOverrider: Number;
  maximumOverrider: Number;
}
